import { render, staticRenderFns } from "./selectStudents.vue?vue&type=template&id=b288642a&scoped=true&"
import script from "./selectStudents.vue?vue&type=script&lang=js&"
export * from "./selectStudents.vue?vue&type=script&lang=js&"
import style0 from "./selectStudents.vue?vue&type=style&index=0&id=b288642a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b288642a",
  null
  
)

export default component.exports